module.exports = __webpack_public_path__ + "img/greenBarEnd.3d53db74.svg";